import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'
import { addToCartButtonFields, PRODUCT_PAGES, titleFields } from './_shared-library'

const GRID_FIELDS: FieldSchema[] = [...titleFields('Featured toys', 'Loved by kids, trusted by parents.'), { key: 'viewAllLink', label: '“See all” link', type: 'string', default: '/shop' }]

/** v1 card grid, v2/v4 a lead card on a pastel panel beside smaller ones, v3/v6 compact rows (v6 with a special-offer card). */
export const schema: ComponentSchema = {
  type: 'product-grid',
  label: 'Product grid',
  description: 'Products as a card grid, a lead product beside smaller ones, or compact rows.',
  supportedPages: PRODUCT_PAGES,
  variants: [
    { id: 'v1', label: 'Card grid', fields: GRID_FIELDS },
    { id: 'v2', label: 'Lead card and 6', fields: GRID_FIELDS },
    { id: 'v3', label: 'Compact rows', fields: GRID_FIELDS },
    { id: 'v4', label: 'Lead card and 4', fields: GRID_FIELDS },
    {
      id: 'v6',
      label: 'Compact rows with special offer',
      fields: [...GRID_FIELDS, { key: 'offerEndsAt', label: 'Offer ends at (ISO date)', type: 'string' }],
    },
  ],
  commonFields: [
    { key: 'categoryId', label: 'Category (optional)', type: 'category-select' },
    {
      key: 'orderBy',
      label: 'Order',
      type: 'select',
      options: [
        { label: 'Newest', value: 'newest_first' },
        { label: 'Biggest discount', value: 'discount_desc' },
        { label: 'Price: low to high', value: 'price_asc' },
        { label: 'Price: high to low', value: 'price_desc' },
        { label: 'Name: A–Z', value: 'name_asc' },
      ],
      default: 'newest_first',
    },
    { key: 'limit', label: 'Products', type: 'number', default: 8 },
    ...addToCartButtonFields,
    ...SECTION_STYLE_FIELDS,
  ],
}
